import { create } from 'zustand';
import { buildApiUrl } from '../config/api';

export const useAuthStore = create((set) => ({
  isAuthenticated: false,
  isChecking: true,
  isLoggingIn: false,
  user: null,

  checkAuth: async () => {
    set({ isChecking: true });
    try {
      const response = await fetch(buildApiUrl('/ai-studio/v1/auth/me'), {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) {
        set({ isAuthenticated: false, user: null, isChecking: false });
        return false;
      }

      const result = await response.json();
      const user = result.user || null;

      set({
        isAuthenticated: true,
        user,
        isChecking: false,
      });

      return true;
    } catch (_error) {
      set({ isAuthenticated: false, user: null, isChecking: false });
      return false;
    }
  },

  login: async (username, password) => {
    set({ isLoggingIn: true });
    try {
      const response = await fetch(buildApiUrl('/ai-studio/v1/auth/login'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.error || 'ログインに失敗しました');
      }

      set({
        isAuthenticated: true,
        user: result.user || { username },
        isLoggingIn: false,
      });

      return true;
    } catch (error) {
      set({ isAuthenticated: false, user: null, isLoggingIn: false });
      throw error;
    }
  },

  logout: async () => {
    try {
      await fetch(buildApiUrl('/ai-studio/v1/auth/logout'), {
        method: 'POST',
        credentials: 'include',
      });
    } catch (_error) {
      // no-op
    } finally {
      set({ isAuthenticated: false, user: null });
    }
  },
}));